import { getUrl, Request } from "../../request";

export const getEmployees = (page = 1, q) => {
  return Request.get(
    getUrl("/api/v1/service_center/service-center-employees/"),
    { page, ...(q && { q }), limit: 10 }
  );
};

export const patchEmployee = (id, isActive) => {
  return Request.put(
    getUrl(`/api/v1/service_center/service-center-employees/${id}/`),
    {
      is_active: isActive,
    }
  );
};

export const createEmployee = (first_name, last_name, phone_number) => {
  return Request.post(
    getUrl("/api/v1/service_center/service-center-employees/"),
    {
      first_name,
      last_name,
      phone_number,
    }
  );
};
